import { IGenericJSON } from '../helpers/interface';

export class District {
  id: number;
  name: string;

  constructor(data: IGenericJSON) {
    this.id = data['id'];
    this.name = data['name'];
  }

  public static digest(data: IGenericJSON): District {
    return new District(data);
  }

  public static digestResponse(data: IGenericJSON[]): District[] {
    const ret: District[] = [];
    data.forEach((u: IGenericJSON): void => {
      ret.push(this.digest(u));
    });
    return ret;
  }
}
